import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../common/http/http-utils';

@Injectable()
export class LicenseAlertService {

    private API_BASE = '/hybridity/api';

    constructor( public http: HttpClient) {

    }
    getLicenseActivationStatus() {
        return this.http.get(HttpUtils.getBaseUrl() + this.API_BASE + '/license/hcx/activationStatus');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/license-alert.service.ts